/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

/**
 * Service imports.
 */
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { GetService } from '../../dataservices/get.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { AutoFillDetail } from 'src/app/onboarding/interface/global.model';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT, HOME_ENTRY, SUBMIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';


/**
 * Drug Order Form Component
 */
@Component({
  selector: 'app-drug-order-form',
  templateUrl: './drug-order-form.component.html',
  styleUrls: ['./drug-order-form.component.scss']
})
export class DrugOrderFormComponent implements OnInit, OnDestroy {

  @Input() data;
  public buttonGreen = false;
  public api_in_process = false;
  public bsValue = new Date();
  public bsRangeValue: Date[];
  public minDate: Date = new Date();
  public maxDate: Date = new Date('01/01/2999');
  public sminDate: Date = new Date();
  public smaxDate: Date = new Date('01/01/2999');
  public isValidStartDate = true;
  public is_disable_start_date = false;
  public is_disable_end_date = true;
  public start_date_placeholder: string = this.mls.languageText.drug_order_form.key24;
  public start_date_err_msg: string = this.mls.languageText.drug_order_form.key25;
  public isSkpModalShown = true;
  public confirmAction = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public d: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public geoLocation: any;
  public finished = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public timeslot: any;
  public autofilData: AutoFillDetail[];
  public dataObj = {
    drug_id: '',
    name: '',
    mobile: '',
    email: '',
    address: '',
    postcode: '',
    timeSlot: '',
    date: ''
  };
  public orderButton = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public currLocation: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public tempCurrlocation: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public drug_id: any;

  /**
   * drug form
   */
  public drugForm: FormGroup;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public formData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorName: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorMobile: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorEmail: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorAddress: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorPostcode: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorTimeslot: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorDate: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorEmailValid: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorNameValid: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorMobileValid: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorAddressValid: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorPostcodeValid: any = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public adresstemp: any;
  public coordinates;
 /**
  * flag variable to render form
  */
  public render = false;
  /**
   * Hold consent data.
   */
  public consent: { is_consent: number, text: string };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Place order button text.
   */
  public orderButtonText: string;

  private startTime = 0;

  constructor(
    private getApiser: GetService,
    public fcs: FunCollectionService,
    private postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    private dss: DataStorageService,
    public multiLangService: MultiLangService,
    public masterService: MasterserviceService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics,
    public formBuilder: FormBuilder) {
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (this.data.data[0].data != undefined && this.data.data[0].data != '') {
      this.drug_id = this.data.data[0].data;
    } else {
      this.drug_id = this.data.data;
    }
    this.adresstemp = this.dss.currentGeolocation;
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.DRUG_SAMPLE,
      entity_code: this.drug_id,
      source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
      current_screen_name: SCREEN_NAME.DRUG_REQUEST_SAMPLE,
      start_time: this.startTime = new Date().getTime()
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.getDrugTimeslot();
  }

  /**
   * update location
   */
  updatelocation(): void {

    this.currLocation = this.dss.currentGeolocation;
    this.tempCurrlocation = this.currLocation.address_components;


    this.drugForm.get('address').setValue(this.currLocation.formatted_address);



    for (let i = 0; i <= this.currLocation.address_components?.length; i++) {
      if (this.currLocation.address_components[i].types != undefined) {
        // No Code
      }

      for (let j = 0; j <= this.currLocation.address_components[i].types?.length; j++) {

         if (this.currLocation.address_components[i].types[j] == 'postal_code') {
           this.drugForm.get('postcode').setValue(this.currLocation.address_components[i].long_name);
         }


      }

    }
  }

  initializeForm(formData: AutoFillDetail[]): void {
    this.drugForm = this.formBuilder.group({
    });
    for (const item of formData) {
      this.drugForm.addControl(item.key, this.formBuilder.control(
        {value:item.value, disabled: item.validation.editable === 0}));
      const control = this.drugForm.get(item.key);
      if (item.validation.required === 1) {
        control.setValidators(Validators.required);
      }
      if (item.key === 'mobile') {
        control.setValidators(Validators.minLength(4));
      }
    }
    this.render = true;
  }
  /**
   * get Drug Time slot
   */
  getDrugTimeslot(): void {
    this.finished = true;
    this.subscriptions.add(this.getApiser.getDrugTimeslot(this.drug_id).subscribe(resData => {
      this.finished = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.autofilData = data.data.autofill_details;
          this.timeslot = data.data.preferred_time_slot;
          this.orderButtonText = data.data.order_button_label;
          this.consent = data.data.consent;
          /**
           * OrderStartDate from API and set to min date of drug to order.
           */
          this.initializeForm(this.autofilData);
          const orderStartDate = data.data.order_start_date;
          this.sminDate = new Date(orderStartDate);
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * go back
   */
  goback(): void {
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.dss.suggAssList = [];
    this.dss.selected_suggAssList = [];

    this.masterService.showWebModal.next(displayObj);
  }

  /**
   * onkey
   */
  onkey(): void {
    this.checkField();
    this.errorName = '';
    this.errorMobile = '';
    this.errorEmail = '';
    this.errorAddress = '';
    this.errorPostcode = '';
    this.errorEmailValid = '';
    this.errorNameValid = '';
    this.errorMobileValid = '';
    this.errorAddressValid = '';
    this.errorPostcodeValid = '';
  }

  /**
   * onSubmit
   */
  onSubmit(): boolean {
    const submitData :SUBMIT={
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.DRUG_SAMPLE,
      entity_code: this.drug_id,
      current_screen_name:SCREEN_NAME.DRUG_REQUEST_SAMPLE ,
      start_time:this.startTime ,
      action_on: ACTION_ON.DRUG_SAMPLE_FORM,
      cta_type: CTA_TYPE.BUTTON,
      action_type: ACTION_TYPE.CLICK
    }
      this.analyticSdk.analyticService.SUBMIT(submitData);
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    // eslint-disable-next-line no-useless-escape
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    this.dataObj.drug_id = this.data.data[0].data,
      this.dataObj.name = this.drugForm.get('name').value,
      this.dataObj.mobile = this.drugForm.get('mobile').value,
      this.dataObj.email = this.drugForm.get('email').value,
      this.dataObj.address = this.drugForm.get('address').value,
      this.dataObj.postcode = this.drugForm.get('postcode').value;
    if (this.drugForm.get('name').value?.length < 1) {
      this.errorName = true;
      return false;
    } else if (this.drugForm.get('mobile').value?.length < 1) {
      this.errorMobile = true;
      return false;
    } else if (this.drugForm.get('mobile').value?.length < 4 && this.drugForm.get('mobile').value?.length > 1) {
      this.errorMobileValid = true;
      return false;
    } else if (this.drugForm.get('email').value?.length < 1) {

      this.errorEmail = true;
      return false;
    } else if (regex.test(this.drugForm.get('email').value) == false && this.drugForm.get('email').value?.length > 3) {
      this.errorEmailValid = true;
      return false;
    } else if (this.drugForm.get('address').value?.length < 1) {
      this.errorAddress = true;
      return false;
    } else if (this.drugForm.get('address').value?.length > 1 && this.drugForm.get('address').value?.length < 4) {
      this.errorAddressValid = true;
      return false;
    } else if (this.drugForm.get('postcode').value?.length < 1) {
      this.errorPostcode = true;
      return false;
    } else if (this.drugForm.get('postcode').value?.length > 1 && this.drugForm.get('postcode').value?.length < 3) {
      this.errorPostcodeValid = true;
      return false;
    } else if (this.dataObj.timeSlot?.length == 0) {
      this.errorTimeslot = true;
      return false;
    } else if (this.dataObj.date?.length == 0 || this.dataObj.date === undefined) {
      this.errorDate = true;
      return false;
    }



    this.api_in_process = true;
    this.subscriptions.add(this.postSer.postPlaceorder(this.dataObj).subscribe(resData => {
      this.api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.goback();
          const x = { drug_id: this.dataObj.drug_id, orderButton: this.orderButton };
          this.dss.drugOrderFinished.next(x);
          this.fcs.showSuccess(data['msg'], 'Success');
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data, 'generate_certificate');
        }
      });
    }));
  }

  /**
   * change Client
   */
  changeClient(e): void {
    this.errorTimeslot = false;
    this.drugForm.get('time_range').setValue(e);
    this.dataObj.timeSlot = e;
  }

  /**
   * set Date
   */
  setDate(dateObj): void {
    this.errorDate = false;
    if (dateObj.dateFor == 'startDate') {
      this.isValidStartDate = true;
      this.dataObj.date = dateObj.Date;
    }
    this.drugForm.get('date').setValue(dateObj.Date);
  }

  /**
   * check Field
   */
  checkField(): boolean {
    // const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    this.buttonGreen = true;
    return true;
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.DRUG_SAMPLE,
      entity_code: this.drug_id,
      current_screen_name: SCREEN_NAME.DRUG_REQUEST_SAMPLE,
      start_time: this.startTime,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
